<div (click)="toggleControl.setValue(!toggleControl.value)" class="flex items-center text-sm gap-2 cursor-pointer">
  @if (!toggleControl.value) {
    @if (showLabel()) {
      <span [innerText]="'SETTINGS.THEME.LIGHT' | translate"></span>
    }
    <gan-lucid-icon iconId="sun" />
  }
  @if (toggleControl.value) {
    @if (showLabel()) {
      <span [innerText]="'SETTINGS.THEME.DARK' | translate"></span>
    }
    <gan-lucid-icon iconId="moon" />
  }
</div>
